import type { ApiResponse } from "@entrilia/shared/api/types.ts";
import type { ExportResponse } from "../../../../../../../api/types/svTypes.ts";

export const EXPORT_FAILED = "An error occurred while exporting the file. Please try again.";
export const EXPORT_TIMED_OUT = "An error occurred while generating an export file. Please try again.";

interface Dependencies {
  checkReady: (token: string) => Promise<ApiResponse<ExportResponse>>;
  download: (token: string) => Promise<void>;
  wait: (milliseconds: number) => Promise<void>;
}

export const exportFile = async (
  request: () => Promise<ApiResponse<ExportResponse>>,
  dependencies: Dependencies,
  signal: AbortSignal,
  maxAttempts = 200
): Promise<void> => {
  signal.throwIfAborted();
  const started = await request();
  signal.throwIfAborted();
  if (!started.success || started.data.error) {
    throw new Error(EXPORT_FAILED);
  }

  for (let attempt = 0; attempt <= maxAttempts; attempt += 1) {
    const response = await dependencies.checkReady(started.data.token);
    signal.throwIfAborted();
    if (!response.success || response.data.error) {
      throw new Error(EXPORT_FAILED);
    }
    if (response.data.fileProcessed) {
      await dependencies.download(started.data.token);
      return;
    }
    if (attempt < maxAttempts) {
      await dependencies.wait(1500);
      signal.throwIfAborted();
    }
  }
  throw new Error(EXPORT_TIMED_OUT);
};
